import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-neutral-900 text-white py-8 px-4 sm:px-8 lg:px-16">
            <div className="flex flex-col sm:flex-row justify-between">
                <div>
                    <h3 className="text-xl font-bold mb-4">Nana Hana</h3>
                    <p>Our brand is a fusion of various alternative fashion genres, from punk and goth to kawaii and streetwear.</p>
                </div>
                <div className="flex flex-col sm:flex-row">
                    <ul className="list-none space-y-2 sm:space-y-0 sm:mr-8">
                        <li><Link to="/about-us">About Us</Link></li>
                        <li><Link to="/contact-us">Contact Us</Link></li>
                        <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                    </ul>
                    <ul className="list-none space-y-2 sm:space-y-0">
                        <li><Link to="/faq">FAQ</Link></li>
                        <li><Link to="/shipping-and-returns">Shipping & Returns</Link></li>
                        <li><Link to="/size-chart">Size Chart</Link></li>
                    </ul>
                </div>
            </div>
            <div className="text-center mt-4 sm:mt-8">
                <p>&copy; 2024 Nana Hana. All rights reserved.</p>
                <div className="flex justify-center space-x-2 mt-2">
                    {/* Add social media links here */}
                    {/* <a href="https://www.instagram.com/nana_hana_official" target="_blank" rel="noopener noreferrer">
                        <img src="/instagram-logo.png" alt="Instagram" className="w-6 h-6" />
                    </a>
                    <a href="https://www.facebook.com/nana.hana.official" target="_blank" rel="noopener noreferrer">
                        <img src="/facebook-logo.png" alt="Facebook" className="w-6 h-6" />
                    </a>
                    <a href="https://twitter.com/nana_hana_brand" target="_blank" rel="noopener noreferrer">
                        <img src="/twitter-logo.png" alt="Twitter" className="w-6 h-6" />
                    </a> */}
                </div>
            </div>
        </footer>
    );
};

export default Footer;